// extracted by mini-css-extract-plugin
export default {"RFLegend":"RFLegend---TbfIF","addButton":"addButton---AQ0hc","linkButton":"linkButton---f9wrn","fullWidth":"fullWidth---h57jU"};